import * as React from 'react'
import { createContext, PropsWithChildren, ReactElement, useContext } from 'react'
import useAxios from '../hooks/useAxios'
import { AxiosError, AxiosInstance } from 'axios'
import { toast, ToastContentProps } from 'react-toastify'
import { Text } from '@fluentui/react'
import ErrorPopover from '../components/Toast/ErrorPopover'
import { normalizeAxiosError } from '../reducers/errorReducer'
import { accountingToastStyle } from '../components/Preview/AccountingSubmissionPreview'
import AuthorizationContext, { Host } from './AuthorizationContext'
import { toastContainerId } from '../pages/App'

export type MolieState = {
    code?: string
    state?: string
    error?: string
    errorDescription?: string
}

export type MollieContextType = {
    authorize: (location: Location) => void
}

const doAuthorize = (
    axios: AxiosInstance,
    host: Host,
    location: Location,
    toastStyles: Record<'toaster' | 'button' | 'details' | 'moreInfo', string>,
) => {
    //skip when there are no succes or failure parameters
    if (location.hash?.indexOf('/mollie') < 0) {
        return
    }
    if (location.hash?.indexOf('success') >= 0) {
        const values = location.hash.split('/')

        toast.promise(
            axios.get<string>(`/payment/mollie/authorization/${host.RowKey}?code=${values[3]}&state=${values[4]}&hostKey=${host.RowKey}`, {
                baseURL: process.env.API_HOST,
                headers: { SuppressErrors: true },
            }),
            {
                pending: 'Bezig met instellen van de Mollie koppeling',
                success: {
                    render: () => `De Mollie koppeling is succesvol geautoriseerd`,
                },
                error: {
                    render: ({ data }: ToastContentProps<AxiosError>) => {
                        return (
                            <div className={toastStyles.toaster}>
                                <Text>Er is een fout opgetreden bij het autoriseren van de Mollie koppeling.</Text>
                                <ErrorPopover error={normalizeAxiosError(data)} styles={toastStyles} />
                            </div>
                        )
                    },
                },
            },
            {
                autoClose: false,
                containerId: toastContainerId,
            },
        )
    }

    if (location.hash?.indexOf('error') >= 0) {
        const values = location.hash.split('/')
        console.log(values[3])
        console.log(values[4])

        toast.error(
            <>
                <div className={toastStyles.toaster}>
                    <Text>Er is een fout opgetreden bij het autoriseren van de Mollie koppeling.</Text>
                    <>
                        <Text>Foutmelding: {values[3]}</Text>
                        <Text>Details: {values[4]}</Text>
                    </>
                </div>
            </>,
            {
                autoClose: false,
                containerId: toastContainerId,
            },
        )
    }
}

const MollieContext = createContext<MollieContextType>(null)

export function MollieProvider(props: PropsWithChildren): ReactElement {
    const axios = useAxios()
    const { host: currentHost } = useContext(AuthorizationContext)
    const styles = accountingToastStyle()

    return (
        <MollieContext.Provider
            value={{
                authorize: (location: Location) => doAuthorize(axios, currentHost, location, styles),
            }}
        >
            {props.children}
        </MollieContext.Provider>
    )
}

export default MollieContext
